/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class AgentCompatibilityAssetPresetEnum.
* @enum {}
* @readonly
*/
export default class AgentCompatibilityAssetPresetEnum {
    
        /**
         * value: "〜500万円"
         * @const
         */
        "_500万円以下" = "〜500万円";

    
        /**
         * value: "〜1,000万円"
         * @const
         */
        "_1000万円以下" = "〜1,000万円";

    
        /**
         * value: "〜3,000万円"
         * @const
         */
        "_3000万円以下" = "〜3,000万円";

    
        /**
         * value: "500万〜5,000万円"
         * @const
         */
        "_500万5000万円" = "500万〜5,000万円";

    
        /**
         * value: "1,000万〜1億円"
         * @const
         */
        "_1000万1億円" = "1,000万〜1億円";

    
        /**
         * value: "3,000万円〜"
         * @const
         */
        "_3000万円以上" = "3,000万円〜";

    
        /**
         * value: "制限なし"
         * @const
         */
        "制限なし" = "制限なし";

    

    /**
    * Returns a <code>AgentCompatibilityAssetPresetEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/AgentCompatibilityAssetPresetEnum} The enum <code>AgentCompatibilityAssetPresetEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

